(function () {
    'use strict';

    angular
        .module('cacmEventModule')
        .directive('cacmEvent', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn', 'cacmService'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn, cacmService) {

        var directiveScope = _.clone(boxTmplScope);

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', '$state',
                function ($rootScope,   $scope,   $controller, $state) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/cacm/event/cacmEvent.[Template].tpl.html';
                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'CACMControlManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'Event';

                    $controller('BoxTmplController', { $scope: $scope });

                    $scope.canEditEvent = $scope.boxPermissions.Edit;

                    // Highlighting
                    function setupHighlighting(result) {
                        var highlighting = [];
                        for (var p in result) {
                            if (result.hasOwnProperty(p) && result[p] instanceof Array) {
                                if (p === 'Description') {
                                    $scope.boxModel.Description = result[p][0];
                                } else {
                                    Array.prototype.push.apply(highlighting, result[p]);
                                }
                            }
                        }
                        return highlighting.length > 0 ? highlighting : null;
                    }

                    if ($scope.boxModel && $scope.boxModel.highlighting) {
                        $scope.boxModel.highlighting = setupHighlighting($scope.boxModel.highlighting);
                    }

                    // Selection
                    $scope.selection = {
                        showCheckbox: false,
                        selected: false
                    };

                    if ($scope.boxContext && $scope.boxContext.selectionService) {
                        $scope.selection.selected = $scope.boxContext.selectionService.selectedItems.indexOf($scope.boxModel.CACMEventID) > -1;
                    }

                    $scope.$watchCollection('boxContext.selectionService.selectedItems', function (/*undefined|Array*/ newVal) {
                        if (newVal) {
                            $scope.selection.selected = newVal.indexOf($scope.boxModel.CACMEventID) > -1;
                        }
                    });

                    $scope.checkboxHover = function(hover) {
                        if ($scope.boxContext.selectionService && !$scope.boxModel.IsGrouped) {
                            $scope.selection.showCheckbox = hover;
                        }
                    };

                    $scope.selectionChanged = function () {
                        $scope.boxContext.selectionService.itemSelectionChanged($scope.boxModel, $scope.selection.selected);
                    };

                    $scope.isInSelectionMode = function() {
                        return ($scope.selection && $scope.selection.showCheckbox)
                            || ($scope.boxContext && $scope.boxContext.selectionService && $scope.boxContext.selectionService.selectionMode);
                    };

                    $scope.isSelectionCompatible = function () {
                        if ($scope.boxModel.IsGrouped) return false;
                        if (!$scope.boxContext || !$scope.boxContext.selectionService) return false;
                        if ($scope.boxContext.selectionService.selectedItems.length === 0) return true;

                        return $scope.boxContext.selectionService.selectedItemsObjects[0].CACMTestID === $scope.boxModel.CACMTestID;
                    };

                    $scope.goToEvent = function(event) {
                        if (!$scope.isInSelectionMode()) {
                            $scope.clickOnBox({event: event});
                        }
                    };

                    $scope.goToLinkedControlTest = function () {
                        if (!$scope.boxModel.ControlID || !$scope.boxModel.ControlTestID) return;
                        $state.go('cacmLinkedControlTest', {
                            ControlID: $scope.boxModel.ControlID,
                            ControlTestID: $scope.boxModel.ControlTestID
                        });
                    };

                    // Convert hexadecimal color code to rgba with specific opacity
                    $scope.convertHex = function (hex, opacity) {
                        var r, g, b;
                        hex = hex.replace('#', '');
                        r   = parseInt(hex.substring(0, 2), 16);
                        g   = parseInt(hex.substring(2, 4), 16);
                        b   = parseInt(hex.substring(4, 6), 16);

                        return 'rgba(' + r + ',' + g + ',' + b + ',' + (opacity ? opacity : .2) + ')';
                    };

                    $scope.removeFromGroup = function (event) {
                        if (!event._isUngrouping) {
                            event._isUngrouping = true;
                            cacmService
                                .removeEventFromGroup(event.CACMEventID, event.ParentID)
                                .then(function () {
                                    event._isUngrouping = false;
                                    var idx = -1;
                                    $scope.boxModel.some(function (item, index) {
                                        if (item.CACMEventID === event.CACMEventID) {
                                            idx = index;
                                            return true;
                                        }
                                        return false;
                                    });
                                    if (idx > -1) {
                                        $scope.boxModel.splice(idx, 1);
                                    }
                                });
                        }
                    };
                }
            ],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();
